// Angular:
import { Directive } from '@angular/core';

@Directive({
    selector: '[tmStepIndicatorIcon]',
    standalone: false
})
export class StepIndicatorIconDirective {}
